import ListHeader from "@/common/components/ListHeader";
import Tabs from "@/common/components/Tabs";
import { FileBoxIcon } from "lucide-react";
import MaintenanceObjectiveSystemsList from "../objectiveSystems/pages/List";
import MaintenanceObjectivePartsList from "../objectiveParts/pages/List";
import MaintenanceObjectiveActionsList from "../objectiveActions/pages/List";
import useUserPermissions from "@/common/hooks/useUserPermissions";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MaintenanceObjectiveMaintenance = () => {
  const { userPermissionsSet, isUserPermissionsPending } = useUserPermissions();

  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isUserPermissionsPending && location.pathname.split('/').filter(Boolean).length === 1) {
      if (userPermissionsSet.has('Admin::Maintenance::ObjectiveSystems::Filter')) {
        return navigate('systems');
      }

      if (userPermissionsSet.has('Admin::Maintenance::ObjectiveParts::Filter')) {
        return navigate('parts');
      }

      return navigate('actions');
    }
  }, [isUserPermissionsPending]);

  return (
    <div className='max-h-[calc(100vh-64px)]'>
      <ListHeader
        Icon={<FileBoxIcon className="w-10 h-10" strokeWidth={1} />}
        title="Objetos de manutenção"
      />

      <Tabs
        tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none mt-4"
        tabsTriggerClassName="flex-1 h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
        tabsContentClassName="mt-6"
        tabsList={[
          {
            value: 'systems',
            label: 'Sistemas',
            body: <MaintenanceObjectiveSystemsList />,
            operationKlassToCheckPermission: 'Admin::Maintenance::ObjectiveSystems::Filter',
          },
          {
            value: 'parts',
            label: 'Partes',
            body: <MaintenanceObjectivePartsList />,
            operationKlassToCheckPermission: 'Admin::Maintenance::ObjectiveParts::Filter',
          },
          {
            value: 'actions',
            label: 'Ações',
            body: <MaintenanceObjectiveActionsList />,
            operationKlassToCheckPermission: 'Admin::Maintenance::ObjectiveActions::Filter',
          },
        ]}
        isLoading={isUserPermissionsPending}
        skeletonsCount={3}
      />
    </div>
  );
}

export default MaintenanceObjectiveMaintenance;
